import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { DatabaseOutlined } from '@ant-design/icons';
import SwineAnimals from "./index";
import ViewSwine from "./view";
import EditSwine from "./edit";

const swineRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Swines",
		basePath: "animal-inventory/swines",
		mainComponent: <SwineAnimals />,
	    layout: "/console",
		icon: <DatabaseOutlined className="h-6 w-6" />,
	    subTitle:"Swine",
	    viewComponent: <ViewSwine />,
	    createComponent: <EditSwine />,
	    editComponent: <EditSwine />,
	})
]

export default swineRoutes;